/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
function e(){var e;const o=null==(e=globalThis.require)?void 0:e.modules;if(o){const e=Object.keys(o);for(const l of e)-1!==l.search(".glsl")&&delete o[l]}}export{e as removeLoadedShaderModules};
